module.exports = __webpack_public_path__ + "static/predictiveTeam-8daed791e41609c678096a29e8168253.jpg";